import type { RouteRecordRaw, Router } from 'vue-router'

const PropertyRoutes: RouteRecordRaw = {
  path: '/claim/property',
  name: 'PropertyModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'PropertyMainRoute',
      component: () => import('./views/PropertyView.vue'),
      meta: {
        title: 'property.propertyClaims',
      },
    },
    {
      path: 'create',
      name: 'PropertyCreateRoute',
      component: () => import('./views/PropertyUpsertView.vue'),
      meta: {
        title: 'property.createProperty',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:propertyId',
      name: 'PropertyEditRoute',
      component: () => import('./views/PropertyUpsertView.vue'),
      meta: {
        title: 'property.editProperty',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:propertyId',
      name: 'ViewPropertyRoute',
      component: () => import('./views/SinglePropertyView.vue'),
      meta: {
        title: 'property.ViewProperty',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(PropertyRoutes)
}
